import { render, staticRenderFns } from "./SubmissionFormStatementsItem.vue?vue&type=template&id=2c040168&scoped=true&"
import script from "./SubmissionFormStatementsItem.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormStatementsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c040168",
  null
  
)

export default component.exports